const state = function () {
	return {
		polos: [],
		poloSelecionado: null,
		poloPadrao: null,
	};
};


export default state;
